import { FilterBean, FilterType } from '@type/filter.type';

function isBooleanFilterClean({ is_null, value }: FilterBean) {
  return is_null === false && !value?.length;
}

function isNumberFilterClean({ is_null, from, to }: FilterBean) {
  return !is_null && typeof from !== 'number' && typeof to !== 'number';
}

function isSkuFilterClean({ value }: FilterBean) {
  return !value?.length;
}

function isTextFilterClean({ is_null, value }: FilterBean) {
  return !(is_null || value?.length);
}

function isReferenceFilterClean({ is_null, value }: FilterBean) {
  return is_null === false && !value?.length;
}

function isDateFilterClean({ is_null, from, to, not_null }: FilterBean) {
  return !is_null && !from && !to && !not_null;
}

function isStatusFilterClean({ value }: FilterBean) {
  return !value?.length;
}

function isInsightFilterClean({ value }: FilterBean) {
  return !value?.length;
}

function isUserFilterClean(filter: FilterBean) {
  return isTextFilterClean(filter);
}

function isSelectFilterClean({ value }: FilterBean) {
  return !value?.length;
}

export function isFilterEmpty(filter: FilterBean) {
  switch (filter.type) {
    case FilterType.Boolean:
      return isBooleanFilterClean(filter);
    case FilterType.Date:
      return isDateFilterClean(filter);
    case FilterType.Reference:
      return isReferenceFilterClean(filter);
    case FilterType.String:
      return isTextFilterClean(filter);
    case FilterType.Sku:
      return isSkuFilterClean(filter);
    case FilterType.Number:
      return isNumberFilterClean(filter);
    case FilterType.Status:
      return isStatusFilterClean(filter);
    case FilterType.Insight:
      return isInsightFilterClean(filter);
    case FilterType.User:
      return isUserFilterClean(filter);
    case FilterType.Select:
      return isSelectFilterClean(filter);
    default:
      return false;
  }
}

export function isComplexValue(val: any): val is FilterBean {
  return 'name' in val && 'type' in val;
}
